var COOKIE_WISHLIST_KEY = "shopify-wishlist";
var COOKIE_DELIMITER = ",";
var BUTTON_ACTIVE_CLASS = "active";
var PRODUCT_SIMPLE_CLASS = "product-simple";
var SELECT_HIDDEN_CLASS = "hidden";
var selectors = {
  button: "[button-wishlist]",
  grid: "[grid-wishlist]",
  gridEmpty: "[grid-wishlist-empty]",
  counter: "[counter-wishlist]",
  selectWishList: "[select-wishlist]",
  boughtJbox: "[bought-jbox]",
  addJewelryBox: "[add-jewelry-box]",
};

// product handle : {{product_handle}}___{{productID}}___{{varianID}}
function getThemeAssetVersion() {
  const links = Array.from(document.querySelectorAll('link[href*="/cdn/shop/t/"]'));

  for (const link of links) {
    const match = link.href.match(/\/t\/(\d+)\//);
    if (match) {
      return match[1]; 
    }
  }

  return null;
}
var themeVersion = getThemeAssetVersion();

var counter = document.querySelector(selectors.counter);
var gridEmpty = document.querySelector(selectors.gridEmpty);

window.onload = function () {
  let customer_id = GetDataCustomerID();

  // move cookie to meta box
  if (customer_id != "") {
    let wishlist = getCookie(COOKIE_WISHLIST_KEY);
    if (wishlist != "") {
      let data = new URLSearchParams();
      wishlist = wishlist.split(COOKIE_DELIMITER);
      for (var index in wishlist) {
        let handle_Pid = wishlist[index].split("___");
        // customer login
        data.append(`items[${index}][handle]`, `${handle_Pid[0]}`);

        if (!handle_Pid[2]) {
          data.append(`items[${index}][pvid]`, `${handle_Pid[1]}`);
        } else {
          data.append(`items[${index}][pvid]`, `${handle_Pid[2]}`);
        }
        data.append(`items[${index}][qty]`, 1);
      }
      setWishlist([]);

      fetch(`https://tools.trollbeads.us/api/v1/wishlist/${customer_id}/add`, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
        body: data,
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (response) {
          if (counter && response.items) {
            counter.innerHTML = response.items.length;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  var buttons = document.querySelectorAll(selectors.button) || [];
  var selectWishList =
    document.querySelectorAll(selectors.selectWishList) || [];

  if (selectWishList.length) setupSelectWishList(selectWishList);

  var grid = document.querySelector(selectors.grid) || false;
  if (grid) setupGrid(grid);

  var wishlist = getWishlist();
  // Update wishlist counter
  if (customer_id == "") {
    if (counter) {
      counter.innerHTML = wishlist.length;
    }
  }

  var jewellerybox =
    document.querySelectorAll(
      ".jewellerybox-container:not(.share-page-jbox)"
    ) || [];
  if (jewellerybox.length > 0) {
    if (customer_id) {
      getJbox();
    }
  }

  var ButtonaddJewelryBox =
    document.querySelectorAll(selectors.addJewelryBox) || [];
  if (ButtonaddJewelryBox.length) addJewelryBoxPage();

  shareWishlistandJBox();
};
var shareWishlistandJBox = function () {
  let param = window.location.href;
  var domain = checkDomain();
  param = new URL(param);
  if (
    param.searchParams.get("wid") != null ||
    param.searchParams.get("jid") != null
  ) {
    let customer_id_share =
      param.searchParams.get("wid") || param.searchParams.get("jid");
    let API_VIEW = `//tools.trollbeads.us/api/v1/wishlist/${customer_id_share}`;
    if (param.searchParams.get("jid") != null) {
      API_VIEW = `//tools.trollbeads.us/api/v1/jewellerybox/${customer_id_share}`;
    }
    fetch(API_VIEW, fetchConfig())
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        console.log(data)
        let wishlist = data.items;
        var requests = wishlist.map(function (item) {
          let template_view = `?variant=${item.pvid}&view=card`;
          if (param.searchParams.get("jid") != null) {
            template_view = `?variant=${item.pvid}&view=ajaxjbox`;
          }

          var productTileTemplateUrl =
            domain + "/products/" + item.handle + `${template_view}`;
          return fetch(productTileTemplateUrl)
            .then(function (res) {
             if (res.status === 200 && res.redirected === false) {
            return res.text();
          } else {
            if (res.status == 404) {
               if (param.searchParams.get("jid") != null) {
               var noteFormatted = encodeURIComponent(item?.note);
                     noteFormatted = cleanTextInput(noteFormatted)
              var fallbackUrl =
                "https://tools.trollbeads.us/api/v1/products/" +
                item.handle +
                `/${Shopify.locale}?variant=${item.pvid}&qty_desired=${item.qty}&item_date=${item.date}&item_note=${noteFormatted}&view=ajaxjboxshare&shop=${Shopify.shop}&themev=${themeVersion}`;
              return fetch(fallbackUrl).then(function (fallbackRes) {
                if (
                  fallbackRes.status === 200 &&
                  fallbackRes.redirected === false
                ) {
                  return fallbackRes.text();
                } else {
                  console.warn("Fallback failed", fallbackRes);
                  return;
                }
              });
               }else{
                   var fallbackUrl =
                  "https://tools.trollbeads.us/api/v1/products/" +
                  item.handle +
                  `/${Shopify.locale}?variant=${item.pvid}&qty_desired=${item.qty}&view=notloggedin&shop=${Shopify.shop}&themev=${themeVersion}`;
                return fetch(fallbackUrl).then(function (fallbackRes) {
                  if (
                    fallbackRes.status === 200 &&
                    fallbackRes.redirected === false
                  ) {
                    return fallbackRes.text();
                  } else {
                    console.warn("Fallback failed", fallbackRes);
                    return;
                  }
                });
               }
               } else {
              return;
            }
          }
            })
            .then(function (data) {
              if (!data) {
                return;
              } else {
                if (param.searchParams.get("wid") != null) {
                  return data.replace("[qty_desired_share_wishlist]", item.qty);
                } else if (param.searchParams.get("jid") != null) {
                  let k = data
                    .replace("[share_jbox_qty_desired]", item.qty)
                    .replace("[share_jbox_date]", item.date)
                    .replace("[share_jbox_note]", "");
                   // OLD LINE .replace("[share_jbox_note]", item.note);
                  return k;
                } else return data;
              }
            });
        });
        Promise.all(requests).then(function (responses) {
          var wishlistProductCards = responses.join("");
          var grid = document.querySelector("[grid-share]") || false;
          grid.innerHTML = wishlistProductCards;
          var selectWishList =
            document.querySelectorAll(selectors.selectWishList) || [];
          alignHeight();
          if (selectWishList.length) {
            setupSelectWishList(selectWishList);
            addItemFromForm();
          }
          var ButtonaddJewelryBox =
            document.querySelectorAll(selectors.addJewelryBox) || [];
          if (ButtonaddJewelryBox.length) addJewelryBoxPage();
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
  };
}

function GetDataCustomerID() {
  let customerID = "";
  if (
    document.querySelector("#PageContainer") &&
    document.querySelector("#PageContainer").dataset.customerId
  ) {
    customerID = document.querySelector("#PageContainer").dataset.customerId;
  }
  return customerID;
}

var addJewelryBoxPage = function () {
  document.querySelectorAll(selectors.addJewelryBox).forEach(function (item) {
    item.addEventListener("click", function (event) {
      if (!this.classList.contains("added")) {
        event.preventDefault();
        if (!this.classList.contains("buton-not-loadding")) {
          item.classList.add("btn--loading");
        }
        let dataBox = item.dataset.addJewelry;
        addJewelryBoxAPI(item.getAttribute("href"), dataBox);
      }
    });
  });
};
var addJewelryBoxAPI = function (url, dataBox) {
  let customerId = GetDataCustomerID();
  var API_BOX_ADD = `//tools.trollbeads.us/api/v1/jewellerybox/${customerId}/add`;
  dataBox = dataBox.split("___");
  let data = new URLSearchParams();
  data.append("items[0][handle]", `${dataBox[0]}`);
  data.append("items[0][pvid]", `${dataBox[1]}`);
  data.append("items[0][qty]", `${dataBox[2]}`);
  // push to varian id
  if (dataBox[3]) {
    data.set("items[0][pvid]", `${dataBox[2]}`);
    data.set("items[0][qty]", `${dataBox[3]}`);
  }
  var today = new Date();
  var dd = String(today.getDate()).padStart(2, "0");
  var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
  var yyyy = today.getFullYear();
  today = yyyy + "-" + mm + "-" + dd;

  data.append("items[0][date]", `${today}`);

  let param = window.location.href;
  param = new URL(param);
  if (param.searchParams.get("variant") != null) {
    data.set("items[0][pvid]", param.searchParams.get("variant"));
  }
  fetch(API_BOX_ADD, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    },
    body: data,
  })
    .then(function (res) {
      return res.json();
    })
    .then(function (response) {
      if (url) {
          window.location.href = url;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};
//
var getJbox = function () {
  let customerId = GetDataCustomerID();
  var API_BOX_VIEW = `//tools.trollbeads.us/api/v1/jewellerybox/${customerId}`;
  var domain = checkDomain();
  fetch(API_BOX_VIEW, fetchConfig())
    .then(function (res) {
      return res.json();
    })
    .then(function (data) {
      let wishlist = data.items;
      var requests = wishlist.map(function (item) {
        var productTileTemplateUrl =
          domain +
          "/products/" +
          item.handle +
          `?variant=${item.pvid}&view=ajaxjbox`;
        return fetch(productTileTemplateUrl).then(function (res) {
          if (res.status === 200 && res.redirected === false) {
            return res.text();
          } else {
            if (res.status == 404) {
              var noteFormatted = encodeURIComponent(item?.note);
              var fallbackUrl =
                "https://tools.trollbeads.us/api/v1/products/" +
                item.handle +
                `/${Shopify.locale}?variant=${item.pvid}&qty_desired=${item.qty}&item_date=${item.date}&item_note=${noteFormatted}&view=ajaxjbox&shop=${Shopify.shop}&themev=${themeVersion}`;
              return fetch(fallbackUrl).then(function (fallbackRes) {
                if (
                  fallbackRes.status === 200 &&
                  fallbackRes.redirected === false
                ) {
                  return fallbackRes.text();
                } else {
                  console.warn("Fallback failed", fallbackRes);
                  return;
                }
              });
            } else {
              return;
            }
          }
        });
      });
      Promise.all(requests).then(function (responses) {
        var wishlistProductCards = responses.join("");
        document.querySelector(".jewellerybox-container").innerHTML =
          wishlistProductCards;
        alignHeight();
        DeleteJboxButton();
        var updateDesiredNumberButton =
          document.querySelectorAll("[btn-update-desired-number]") || [];
        if (updateDesiredNumberButton.length) {
          updateDesiredNumberJbox(updateDesiredNumberButton);
        }
        document.documentElement.classList.remove("modal-closing");
        document.documentElement.classList.remove("modal-open");
      });
    })
    .catch((error) => {
      console.log(error);
    });
};

var getCartAPI = function () {
  fetch("/cart.js")
    .then(function (res) {
      return res.json();
    })
    .then(function (data) {
      if (data.items.length) {
        let data_cart = data.items;
        let variant_id_array = [];
        for (let value of data_cart) {
          variant_id_array.push(value.variant_id);
        }
        return variant_id_array;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};
var DeleteJboxButton = function () {
  var btnEraseJewellerybox = document.querySelectorAll(".btn-erase") || [];
  if (btnEraseJewellerybox.length) {
    btnEraseJewellerybox.forEach(function (button) {
      button.addEventListener("click", function () {
        button.classList.add("btn--loading");
        let product_data = button.dataset.handleInfo;
        let action = "REMOVE";
        updateJbox(product_data, action);
      });
    });
  }
};
function cleanTextInput(input, options = {}) {
  const {
    breakLines = false,
    maxLineLength = 100,
    removeSQLKeywords = true,
    escapeQuotes = false,
    removeEmojis = false
  } = options;

  let cleaned = input;

  // 1. Remove all HTML tags, comments, and scripts
  cleaned = cleaned
    .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '') // Remove <script> blocks
    .replace(/<!--[\s\S]*?-->/g, '')                    // Remove HTML comments
    .replace(/<style[\s\S]*?>[\s\S]*?<\/style>/gi, '')  // Remove <style> blocks
    .replace(/<[^>]+>/g, '')                            // Remove all remaining HTML tags

    // 2. Remove dangerous JS/SQL patterns
    .replace(/on\w+=".*?"/gi, '')                // Remove inline event handlers
    .replace(/javascript:/gi, '')                // Remove javascript:
    .replace(/data:/gi, '')                      // Remove data: URIs
    .replace(/['"`]/g, escapeQuotes ? '\\$&' : '') // Escape or remove quotes
    .replace(/[<>]/g, '')                        // Remove angle brackets
    .replace(/\/\*[\s\S]*?\*\//g, '')            // Remove block comments
    .replace(/--.*?(\n|$)/g, '')                 // Remove SQL comments

  // 3. Optionally remove emojis
  if (removeEmojis) {
    cleaned = cleaned.replace(
      /([\u2700-\u27BF]|[\uE000-\uF8FF]|[\uD800-\uDFFF]|\uFE0F|\u200D|\u2600-\u26FF|\u2190-\u21FF|\u2300-\u23FF|\p{Extended_Pictographic})/gu,
      ''
    );
  }

  // 4. Optionally remove SQL keywords
  if (removeSQLKeywords) {
    cleaned = cleaned.replace(
      /\b(SELECT|DROP|INSERT|DELETE|UNION|UPDATE|WHERE|OR|AND|FROM|TABLE|INTO|VALUES|EXEC|CAST|CHAR)\b/gi,
      ''
    );
  }

  // 5. Normalize whitespace
  cleaned = cleaned
    .replace(/\s{2,}/g, ' ')      // Collapse multiple spaces
    .replace(/\r\n|\r/g, '\n')    // Normalize line breaks
    .replace(/\n{3,}/g, '\n\n')   // Collapse extra blank lines
    .trim();

  // 6. Optional word-wrap
  if (breakLines) {
    const lines = cleaned.split('\n').map(line =>
      line.length > maxLineLength
        ? line.match(new RegExp(`.{1,${maxLineLength}}`, 'g')).join('\n')
        : line
    );
    cleaned = lines.join('\n');
  }

  return cleaned;
}

var updateJbox = function (product_data, action, note = "", date = "") {
  let customerId = GetDataCustomerID();
  let API_UPDATE = "";
  if (action == "ADD") {
    API_UPDATE = `//tools.trollbeads.us/api/v1/jewellerybox/${customerId}/add`;
  } else {
    API_UPDATE = `//tools.trollbeads.us/api/v1/jewellerybox/${customerId}/remove`;
  }

  let product_data_array = product_data.split("___");
  let data = new URLSearchParams();

  data.append("items[0][handle]", `${product_data_array[0]}`);
  data.append("items[0][pvid]", `${product_data_array[2]}`);
  data.append("items[0][qty]", `${product_data_array[3]}`);
  data.append("items[0][note]", `${cleanTextInput(note)}`);
  data.append("items[0][date]", `${date}`);

  fetch(API_UPDATE, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    },
    body: data,
  })
    .then(function (res) {
      return res.json();
    })
    .then(function (response) {
      var jewellerybox =
        document.querySelectorAll(".jewellerybox-container") || [];
      if (jewellerybox.length) {
        getJbox();
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

var updateDesiredNumberJbox = function (updateDesiredNumberButton) {
  updateDesiredNumberButton.forEach(function (updateDesiredNumberButton) {
    updateDesiredNumberButton.addEventListener("click", function () {
      let desired_number = updateDesiredNumberButton.closest("div.grid__item");
      desired_number
        .querySelector(".modal-form-edit-jbox")
        .classList.add("modal--is-active");
      document.documentElement.classList.add("modal-open");
    });
  });

  var modalClose =
    document.querySelectorAll(".modal-form-edit-jbox .modal__close") || [];
  modalClose.forEach(function (modalClose) {
    modalClose.addEventListener("click", function () {
      let desired_number = modalClose.closest("div.grid__item");
      document.documentElement.classList.add("modal-closing");
      window.setTimeout(
        function () {
          document.documentElement.classList.remove("modal-closing");
          document.documentElement.classList.remove("modal-open");
          desired_number
            .querySelector(".modal-form-edit-jbox")
            .classList.remove("modal--is-active");
        }.bind(this),
        500
      ); // modal close css transition
    });
  });

  var modalFormEditBox =
    document.querySelectorAll(".modal-form-edit-jbox") || [];
  modalFormEditBox.forEach(function (modalFormEditBox) {
    modalFormEditBox.addEventListener("click", function (event) {
      if (event) {
        if (event.target.closest(".js-modal-close")) {
          // Do not close if using the modal close button
        } else if (event.target.closest(".modal__inner")) {
          return;
        }
      }
      let desired_number = modalFormEditBox.closest("div.grid__item");
      document.documentElement.classList.add("modal-closing");
      window.setTimeout(
        function () {
          document.documentElement.classList.remove("modal-closing");
          document.documentElement.classList.remove("modal-open");
          desired_number
            .querySelector(".modal-form-edit-jbox")
            .classList.remove("modal--is-active");
        }.bind(this),
        500
      ); // modal close css transition
    });
  });

  var buttonSubmitBox = document.querySelectorAll("[btn-update-jbox]") || [];
  buttonSubmitBox.forEach(function (buttonSubmitBox) {
    buttonSubmitBox.addEventListener("click", function () {
      let desired_number = buttonSubmitBox.closest("div.grid__item");
      var event = new Event("change");
      desired_number.querySelector("input.input-quantity").dispatchEvent(event);

      let quantity = desired_number.querySelector("input.input-quantity").value;
      let text_area = desired_number.querySelector("textarea").value;
      let text_date = desired_number.querySelector("input.date").value;

      let quantity_old = buttonSubmitBox.getAttribute("data-desired-number");

      if (Number(quantity) < 1) {
        return;
      }

      let productHandle = buttonSubmitBox.getAttribute("data-product-handle") || false;

      let k = Number(quantity) - Number(quantity_old);

      if (Number(quantity) >= 0) {
        buttonSubmitBox.classList.add("btn--loading");
      }
      let action = "";
      if (k < 0) {
        let _k = -k;
        productHandle += `___${_k}`;
        action = "REMOVE";
      } else {
        productHandle += `___${k}`;
        action = "ADD";
      }

      updateJbox(productHandle, action, text_area, text_date);
    });
  });
};

window.onresize = function () {
  alignHeight();
};

var setupGrid = function (grid) {
  var wishlist = getWishlist();
  var customer_id = GetDataCustomerID();
  var domain = checkDomain();
  // GET DATA WISHLIST
  if (customer_id) {
    var API_WISHLIST_VIEW = `//tools.trollbeads.us/api/v1/wishlist/${customer_id}`;
    fetch(API_WISHLIST_VIEW, fetchConfig())
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        console.log({data, customer_id})
        let wishlist = data.items;
        var requests = wishlist.map(function (item) {
          var productTileTemplateUrl =
            domain +
            "/products/" +
            item.handle +
            `?variant=${item.pvid}&view=card`;

          return fetch(productTileTemplateUrl).then(function (res) {
            if (res.status === 200 && res.redirected === false) {
              return res.text();
            } else {
              if (res.status == 404) {
                var fallbackUrl =
                  "https://tools.trollbeads.us/api/v1/products/" +
                  item.handle +
                  `/${Shopify.locale}?variant=${item.pvid}&qty_desired=${item.qty}&view=card&shop=${Shopify.shop}&themev=${themeVersion}`;
                return fetch(fallbackUrl).then(function (fallbackRes) {
                  if (
                    fallbackRes.status === 200 &&
                    fallbackRes.redirected === false
                  ) {
                    return fallbackRes.text();
                  } else {
                    console.warn("Fallback failed", fallbackRes);
                    return;
                  }
                });
              } else {
                return;
              }
            }
          });
        });
        Promise.all(requests).then(function (responses) {
          var wishlistProductCards = responses.join("");
          grid.innerHTML = wishlistProductCards;
          var selectWishList =
            document.querySelectorAll(selectors.selectWishList) || [];
          var updateDesiredNumberButton =
            document.querySelectorAll("[btn-update-desired-number]") || [];
          alignHeight();
          if (selectWishList.length) {
            setupSelectWishList(selectWishList);
            addItemFromForm();
          }
          if (updateDesiredNumberButton.length) {
            updateDesiredNumber(updateDesiredNumberButton);
          }
          var ButtonaddJewelryBox =
            document.querySelectorAll(selectors.addJewelryBox) || [];
          if (ButtonaddJewelryBox.length) addJewelryBoxPage();
        });
      })
      .catch((error) => {
        console.log(error);
      });
  } else {
    // GET DATA WISH LIST IN COOKIE
    var requests = wishlist.map(function (handle) {
      handle = handle.split("___");
      var productTileTemplateUrl =
        domain + "/products/" + handle[0] + `?variant=${handle[2]}&view=card`;
      return fetch(productTileTemplateUrl).then(function (res) {
      if (res.status === 200 && res.redirected === false) {
              return res.text();
            } else {
              if (res.status == 404) {
                var pvidFormat = handle[2] ?? handle[1]
                var fallbackUrl =
                  "https://tools.trollbeads.us/api/v1/products/" +
                  handle[0] +
                  `/${Shopify.locale}?variant=${pvidFormat}&qty_desired=1&view=notloggedin&shop=${Shopify.shop}&themev=${themeVersion}`;
                return fetch(fallbackUrl).then(function (fallbackRes) {
                  if (
                    fallbackRes.status === 200 &&
                    fallbackRes.redirected === false
                  ) {
                    return fallbackRes.text();
                  } else {
                    console.warn("Fallback failed", fallbackRes);
                    return;
                  }
                });
              } else {
                return;
              }
            }
      });
    });
    Promise.all(requests).then(function (responses) {
      var wishlistProductCards = responses.join("");
      grid.innerHTML = wishlistProductCards;
      var selectWishList =
        document.querySelectorAll(selectors.selectWishList) || [];
      alignHeight();
      if (selectWishList.length) {
        setupSelectWishList(selectWishList);
        addItemFromForm();
      } else {
        gridEmpty.style.display = "block";
      }
    });
  }
};
var alignHeight = function () {
  var arrayHeight = [];
  document
    .querySelectorAll(
      ".wishlist .grid-product__content-wrap .grid-product__title"
    )
    .forEach(function (item) {
      item.style = null;
      arrayHeight.push(parseFloat(item.offsetHeight));
    });
  var max_height = Math.max(...arrayHeight);
  document
    .querySelectorAll(
      ".wishlist .grid-product__content-wrap .grid-product__title"
    )
    .forEach(function (item) {
      item.style.cssText = `
      min-height: ${max_height}px;
    `;
    });
};
var updateDesiredNumber = function (updateDesiredNumberButton) {
  updateDesiredNumberButton.forEach(function (updateDesiredNumberButton) {
    updateDesiredNumberButton.addEventListener("click", function () {
      let desired_number =
        updateDesiredNumberButton.closest("div.desired_number");
      var event = new Event("change");
      desired_number.querySelector("input.input-quantity").dispatchEvent(event);

      let quantity = desired_number.querySelector("input.input-quantity").value;
      let quantity_old = updateDesiredNumberButton.getAttribute(
        "data-desired-number"
      );

      if (Number(quantity) < 0 || Number(quantity) == Number(quantity_old)) {
        return;
      }

      let productHandle =
        updateDesiredNumberButton.getAttribute("data-product-handle") || false;

      let k = Number(quantity) - Number(quantity_old);
      let action = "ADD";

      if (k < 0) {
        action = "REMOVE";
        let _k = -k;
        productHandle += `___${_k}`;
      } else {
        productHandle += `___${k}`;
      }
      if (Number(quantity) > 0) {
        updateDesiredNumberButton.classList.add("btn--loading");
      }
      updateWishlist(productHandle, action);
    });
  });
};
var setupSelectWishList = function (selectWishList) {
  var realCounter = 0;
  selectWishList.forEach(function (selectWishList) {
    let productHandle;
    try {
      productHandle =
        selectWishList?.previousElementSibling?.getAttribute(
          "data-product-handle"
        ) || false;
      realCounter += 1;
    } catch (error) {
      productHandle = false;
    }
    if (!productHandle)
      return console.error(
        "[Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist."
      );
    if (wishlistContains(productHandle))
      selectWishList.previousElementSibling.classList.add(BUTTON_ACTIVE_CLASS);
    // remove class active
    selectWishList.previousElementSibling.addEventListener(
      "click",
      function () {
        if (
          this.classList.contains(BUTTON_ACTIVE_CLASS) ||
          this.classList.contains(PRODUCT_SIMPLE_CLASS)
        ) {
          productHandle = this.getAttribute("data-product-handle") || false;
          if (productHandle) {
            let action = "ADD";
            if (this.classList.contains(BUTTON_ACTIVE_CLASS)) {
              action = "REMOVE";
            }
            updateWishlist(productHandle, action);

            // if (this.classList.contains(BUTTON_ACTIVE_CLASS)) {
            //   if (this.closest(".grid-product-wishlist")) {
            //     this.closest(".grid-product-wishlist").remove();
            //   }
            // }
            this.classList.toggle(BUTTON_ACTIVE_CLASS);
            flyToCart();
          }
        }
      }
    );

    selectWishList.addEventListener("change", function () {
      productHandle =
        this.options[this.selectedIndex].getAttribute("data-product-handle") ||
        false;
      if (productHandle) {
        let action = "ADD";
        updateWishlist(productHandle, action);
        this.previousElementSibling.classList.toggle(BUTTON_ACTIVE_CLASS);
        flyToCart();
      }
    });
  });

   if (counter && window.location.pathname.includes('/wishlist')) counter.innerHTML = realCounter; 
};

var getWishlist = function () {
  var wishlist = getCookie(COOKIE_WISHLIST_KEY);
  // var wishlist = localStorage.getItem(COOKIE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(COOKIE_DELIMITER);
  return [];
};

var setWishlist = function (array) {
  setCookie(COOKIE_WISHLIST_KEY, array, 1);
};

var updateWishlist = function (handle, action) {
  let customer_id = GetDataCustomerID();
  if (customer_id == "") {
    // guest and save to cookie
    var wishlist = getCookie(COOKIE_WISHLIST_KEY);
    if (wishlist != "") {
      wishlist = wishlist.split(COOKIE_DELIMITER);
      var indexInWishlist = wishlist.indexOf(handle);

      let handleurl = handle.split("___");
      var wishlisthandle = [];

      for (var index in wishlist) {
        let k = wishlist[index].split("___");
        wishlisthandle.push(k[0]);
      }

      if (wishlisthandle.indexOf(handleurl[0]) === -1) {
        wishlist.push(handle);
        if (counter) counter.innerHTML = wishlist.length;
        setWishlist(wishlist);
      } else {
        let wishlisthandle = [];
        for (var index in wishlist) {
          let k = wishlist[index].split("___");
          if (!k[0].includes(handleurl[0])) {
            wishlisthandle.push(wishlist[index]);
          }
        }
        if (counter) counter.innerHTML = wishlisthandle.length;
        setWishlist(wishlisthandle);
      }
    } else {
      let k = handle;
      if (counter) counter.innerHTML = "1";
      setWishlist(k);
    }
    var grid = document.querySelector(selectors.grid) || false;
    if (grid) setupGrid(grid);
  } else {
    // customer login

    let API_UPDATE = "";
    if (action == "ADD") {
      API_UPDATE = `https://tools.trollbeads.us/api/v1/wishlist/${customer_id}/add`;
    } else {
      API_UPDATE = `https://tools.trollbeads.us/api/v1/wishlist/${customer_id}/remove`;
    }
    let data = new URLSearchParams();
    let handleurl = handle.split("___");
    data.append("items[0][handle]", `${handleurl[0]}`);

    data.append("items[0][pvid]", `${handleurl[1]}`);

    if (action == "REMOVE") {
      data.append("items[0][qty]", 99999);
    } else {
      data.append("items[0][qty]", 1);
    }

    if (handleurl[2]) {
      data.set("items[0][pvid]", `${handleurl[2]}`);
    }
    if (handleurl[3]) {
      data.set("items[0][qty]", `${handleurl[3]}`);
    }

    fetch(API_UPDATE, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
      body: data,
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (response) {
        if (counter && response.items) {
          counter.innerHTML = response.items.length;
          var grid = document.querySelector(selectors.grid) || false;
          if (grid) setupGrid(grid);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
};

var wishlistContains = function (handle) {
  var wishlist = getWishlist();
  console.log({wishlist, handle})
  handle = handle.split("___");
  var wishlisthandle = [];
  for (var index in wishlist) {
      console.log({index, wishlist, wtf: wishlist[index]})
  if(typeof wishlist[index] === 'string' || wishlist[index] instanceof String){
      let k = wishlist?.[index]?.split("___");
      wishlisthandle.push(k[0]);
  }
 }

  return wishlisthandle.indexOf(handle[0]) !== -1;
};

var setCookie = function (cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};

var getCookie = function (cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};
var checkDomain = function () {
  let domain_href = window.location.href;
  if (domain_href.indexOf("/en/") > -1) {
    return "/en/";
  } else {
    return "";
  }
};
var addItemFromForm = function () {
  var addItemFromForm =
    document.querySelectorAll(".wishlist .form-add-to-cart") || [];
  addItemFromForm.forEach(function (addItemFromForm) {
    new window.theme.AjaxProduct(addItemFromForm);
  });
  //var data = theme.utils.serialize(this.form)
};
// fly to cart
var flyToCart = function () {
  $("body").on("click", ".js-add-to-wishlist-no-profile", function () {
    var cart = $(".header-wishlist");
    if (!$(this).hasClass("active")) {
      return;
    }
    var width = 200;
    var height = 200;
    if ($("body").hasClass("template-product")) {
      var imgtodrag = $(this)
        .closest(".template-product .page-content--product")
        .find("img")
        .eq(0);
      var p_top = imgtodrag.offset().top;
      var p_left = imgtodrag.offset().left;
      if ($(window).width() < 769) {
        p_top = $(this).offset().top;
        p_left = 20;
      }
    } else {
      var imgtodrag = $(this).closest(".grid-product").find("img").eq(0);
      var p_top = imgtodrag.offset().top;
      var p_left = imgtodrag.offset().left;
    }

    if (imgtodrag) {
      width = 0.8 * imgtodrag.width();
      height = 0.8 * imgtodrag.height();
      var imgclone = imgtodrag
        .clone()
        .offset({
          top: p_top,
          left: p_left,
        })
        .css({
          opacity: "0.5",
          position: "absolute",
          height: `${width}px`,
          width: `${height}px`,
          "z-index": "100",
        })
        .appendTo($("body"))
        .animate(
          {
            top: cart.offset().top + 10,
            left: cart.offset().left + 20,
            width: 0,
            height: 0,
          },
          1700
        );

      imgclone.animate(
        {
          width: 0,
          height: 0,
        },
        function () {
          $(this).detach();
        }
      );
    }
  });


  
  $("body").on("change", ".theme-select", function () {
    var cart = $(".header-wishlist");
    if (!$(this).val()) {
      return;
    }
    var width = 200;
    var height = 200;
    if ($("body").hasClass("template-product")) {
      var imgtodrag = $(this)
        .closest(".template-product .page-content--product")
        .find("img.photoswipe__image")
        .eq(0);
      var p_top = imgtodrag.offset().top;
      var p_left = imgtodrag.offset().left;
      if ($(window).width() < 769) {
        p_top = $(this).closest(".product-tile-wishlist-wrap").offset().top;
        p_left = 20;
      }
    } else {
      var imgtodrag = $(this).closest(".grid-product").find("img").eq(0);
      var p_top = imgtodrag.offset().top;
      var p_left = imgtodrag.offset().left;
    }

    if (imgtodrag) {
      width = 0.8 * imgtodrag.width();
      height = 0.8 * imgtodrag.height();
      var imgclone = imgtodrag
        .clone()
        .offset({
          top: p_top,
          left: p_left,
        })
        .css({
          opacity: "0.5",
          position: "absolute",
          height: `${width}px`,
          width: `${height}px`,
          "z-index": "100",
        })
        .appendTo($("body"))
        .animate(
          {
            top: cart.offset().top + 10,
            left: cart.offset().left + 20,
            width: 0,
            height: 0,
          },
          1700
        );

      imgclone.animate(
        {
          width: 0,
          height: 0,
        },
        function () {
          $(this).detach();
        }
      );
    }
  });
};
